import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=0248035c&scoped=true"
import script from "./Timeline.vue?vue&type=script&lang=js"
export * from "./Timeline.vue?vue&type=script&lang=js"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=0248035c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0248035c",
  null
  
)

export default component.exports